import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import "./userTable.css";

const UserTable = ({ users, onUserDeleted }) => {
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDelete = (user) => {
    setOpenDropdownId(null);
    if (onUserDeleted) {
      onUserDeleted(user.id);
    }
  };

  return (
    <div className="user-table-wrapper">
      <table className="user-table">
        <thead>
          <tr>
            <th style={{ width: "15%" }}>
              <div className="th-content">
                <span>ID</span>
                <span className="sort-arrow">▲▼</span>
              </div>
            </th>
            <th style={{ width: "35%" }}>
              <div className="th-content">
                <span>User</span>
                <span className="sort-arrow">▲▼</span>
              </div>
            </th>
            <th style={{ width: "20%" }}>
              <div className="th-content">
                <span>First Name</span>
                <span className="sort-arrow">▲▼</span>
              </div>
            </th>
            <th style={{ width: "20%" }}>
              <div className="th-content">
                <span>Last Name</span>
                <span className="sort-arrow">▲▼</span>
              </div>
            </th>
            <th style={{ width: "10%", textAlign: "center" }}></th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user, index) => {
              const uId = user.id || index;
              const isOpen = openDropdownId === uId;

              return (
                <tr key={uId}>
                  <td>{user.id}</td>
                  <td>{user.email}</td>
                  <td>{user.firstName || user.first_name}</td>
                  <td>{user.lastName || user.last_name}</td>
                  <td className="action-cell">
                    <div
                      ref={isOpen ? dropdownRef : null}
                      className="action-dropdown-wrapper"
                    >
                      <Link to={`/EditUser/${uId}`} className="edit-btn">
                        Edit
                      </Link>

                      <button
                        type="button"
                        onClick={() => setOpenDropdownId(isOpen ? null : uId)}
                        className="dropdown-toggle"
                      >
                      </button>

                      {isOpen && (
                        <div className="dropdown-menu">
                          <button
                            type="button"
                            onClick={() => handleDelete(user)}
                            className="delete-menu-btn"
                          >
                            <FaTrashAlt className="delete-icon" />
                            <span>Delete</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="5" className="no-data-cell">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;